import {GameScore, GameScoresQueryVariables, useGameScoresQuery} from '../../query/graphql';

export const useGameScores = (variables: GameScoresQueryVariables, initialScores?: GameScore[]) => {
  const initialData = initialScores ? {gameScores: initialScores} : undefined;
  return useGameScoresQuery(variables, {select: data => data.gameScores, initialData});
};
